module.exports = __webpack_public_path__ + "static/media/g-2-c.0d9d99b0.jpg";